export function isProductionTelemetryEnabled(): boolean {
  return process.env.NEXT_PUBLIC_APP_ENV?.trim() === "production";
}
